import { MDC_DIALOG_DATA, MdcDialogRef } from '@angular-mdc/web';
import { Component, Inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-aapne-kasse',
  templateUrl: './dialog-aapne-kasse.component.html',
  styleUrls: ['./dialog-aapne-kasse.component.scss']
})
export class DialogAapneKasseComponent implements OnInit {

  minkasse;
  text;

  constructor(
    public dialogRef: MdcDialogRef<any>,
    @Inject(MDC_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit(): void {
    this.minkasse = this.data.kassedata;
    this.text = this.data.text;
  }


  startSalg() {
    this.dialogRef.close('aapen');
  }

  stoppSalg() {
    // TODO
  }

}
